import { BatchEditReq, BatchEditDef } from "../type/batch-edit";

export class BatchEditAdapter {
  static toInputDTO(req: BatchEditReq): any {
    return {
      existing_nodes: req.existing_nodes,
      added_nodes: req.added_nodes,
      edges: req.edges
    };
  }

  static toOutputDTO(res: any): BatchEditDef {
    return res;
  }
}
